<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="grey--text text--darken-1"
        active-class="blue"
        elevation="0"
        v-bind="attrs"
        v-on="on"
        text
      >
        <v-icon>
          {{ boardDensityOptions[boardDensity] }}
        </v-icon>
        <v-icon right>
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="handleBoardDensity('DEFAULT')" dense>
        <v-icon class="grey--text mr-3" small>
          mdi-grid-large
        </v-icon>
        {{ $t('viewOptions.default') }}
      </v-list-item>
      <v-list-item @click="handleBoardDensity('COMPACT')" dense>
        <v-icon class="grey--text mr-3" small>
          mdi-grid
        </v-icon>
        {{ $t('viewOptions.compact') }}
      </v-list-item>
      <v-list-item @click="handleBoardDensity('LIST')" dense>
        <v-icon class="grey--text mr-3" small>
          mdi-format-list-bulleted-type
        </v-icon>
        {{ $t('viewOptions.list') }}
      </v-list-item>
      <!-- <v-divider />
      <v-list-item dense>
        <v-switch
          :value="boardPendingActions"
          @change="setBoardPendingActions(!boardPendingActions)"
          class="board__switch"
          hide-details
          dense
          inset
          flat
        />
        {{ $t('viewOptions.pendentActions') }}
      </v-list-item> -->
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'BoardViewChange',

  computed: {
    ...mapGetters([
      'boardDensity',
      'boardDensityOptions',
      'boardPendingActions',
    ]),
  },

  methods: {
    ...mapActions(['handleBoardDensity']),
    ...mapMutations(['setBoardPendingActions']),
  },
}
</script>
